<template>
  <div>
    <article class="am-article card">
      <div class="am-article-hd">
        <h1 class="am-article-title">{{title}}</h1>
      </div>
      <div class="am-margin-vertical-xl">
        <div class="am-text-center" v-if="loginUser">
          <template v-if="!showProfileEditor">
            <img :src="loginUser.avatarUrl || defaultAvatar" class="avatar am-img-thumbnail am-circle"/>
            {{loginUser.nickName}}，您好！
            <div class="am-margin-top">
              <button class="am-btn am-btn-link am-margin-right-sm" @click="toggleProfileEditor">修改个人信息</button>
              <button class="am-btn am-btn-link am-margin-right-sm" @click="toggleBindEmail">换绑邮箱</button>
              <button class="am-btn am-btn-link" @click="logout">注销登录</button>
            </div>
            <div v-if="showBindEmail" class="am-margin-top am-panel am-panel-default am-radius">
              <div class="am-panel-bd">
                <p class="am-text-sm am-text-secondary am-margin-bottom">换绑后请使用新邮箱接收验证码登录</p>
                <div class="am-form-group" v-if="!bindCodeSent">
                  <div class="am-input-group">
                    <input type="email" class="am-form-field am-radius" placeholder="新邮箱" v-model="bindNewEmail"/>
                    <span class="am-input-group-btn">
                      <button class="am-btn am-btn-primary am-radius" type="button" @click="sendBindEmailCode">发送验证码</button>
                    </span>
                  </div>
                </div>
                <template v-if="bindCodeSent">
                  <div class="am-form-group">
                    <input type="email" class="am-form-field am-radius" placeholder="新邮箱" :value="bindNewEmail" readonly/>
                  </div>
                  <div class="am-form-group">
                    <div class="am-input-group">
                      <input type="text" class="am-form-field am-radius" placeholder="请输入4位验证码" v-model="bindCode" maxlength="4" @keyup.enter="confirmBindEmail"/>
                      <span class="am-input-group-btn">
                        <button class="am-btn am-btn-primary am-radius" type="button" @click="confirmBindEmail">确认换绑</button>
                      </span>
                    </div>
                  </div>
                  <button class="am-btn am-btn-link am-padding-left-0" @click="showBindEmail = false">取消</button>
                </template>
              </div>
            </div>
          </template>
          <div v-if="showProfileEditor" class="am-margin-top">
            <div class="am-form-group">
              <div class="avatar-wrap" @click="triggerProfileAvatarClick">
                <img :src="avatarUrl || defaultAvatar" class="avatar am-img-thumbnail am-circle"/>
              </div>
              <input ref="profileAvatarInput" type="file" accept="image/*" class="am-hide" @change="onAvatarChange"/>
              <p class="am-text-sm am-text-muted">点击头像更换</p>
            </div>
            <div class="am-form-group">
              <input type="text" class="am-form-field am-radius" placeholder="请输入昵称..." v-model="nickName"/>
            </div>
            <div class="am-form-group">
              <input type="email" class="am-form-field am-radius" placeholder="邮箱" :value="loginUser.email" readonly/>
            </div>
            <div class="am-form-group">
              <input type="text" class="am-form-field am-radius" placeholder="您的网站url（可选）" v-model="webUrl"/>
            </div>
            <div class="am-form-group">
              <textarea class="am-form-field am-radius" rows="3" placeholder="个性签名（可选）" v-model="note"/>
            </div>
            <button class="am-btn am-btn-primary am-radius" @click="saveProfile">保存</button>
            <button class="am-btn am-btn-link am-margin-left-sm" @click="toggleProfileEditor">返回</button>
          </div>
        </div>
        <div class="am-text-center" v-else>
          <template v-if="needProfile">
            <span class="am-icon-user am-icon-sm am-block"> 请先完善个人信息后再登录</span>
            <p class="am-text-sm am-text-secondary">完善信息验证码已发送到您的邮箱，请查收后输入下方</p>
            <div class="am-form-group">
              <div class="avatar-wrap" @click="triggerProfileAvatarClick">
                <img :src="avatarUrl || defaultAvatar" class="avatar am-img-thumbnail am-circle"/>
              </div>
              <input ref="profileAvatarInput" type="file" accept="image/*" class="am-hide" @change="onAvatarChange"/>
              <p class="am-text-sm am-text-muted">点击头像更换</p>
            </div>
            <div class="am-form-group">
              <input type="text" class="am-form-field am-radius" placeholder="请输入昵称..." v-model="nickName"/>
            </div>
            <div class="am-form-group">
              <input type="email" class="am-form-field am-radius" placeholder="邮箱" v-model="email" readonly/>
            </div>
            <div class="am-form-group">
              <input type="text" class="am-form-field am-radius" placeholder="您的网站url（可选）" v-model="webUrl"/>
            </div>
            <div class="am-form-group">
              <textarea class="am-form-field am-radius" rows="3" placeholder="个性签名（可选）" v-model="note"/>
            </div>
            <div class="am-form-group">
              <input type="text" class="am-form-field am-radius" placeholder="请输入邮件中的4位验证码" v-model="profileCode" maxlength="4" @keyup.enter="completeProfileAndSend"/>
            </div>
            <button class="am-btn am-btn-primary am-radius" @click="completeProfileAndSend">保存并登录</button>
          </template>
          <template v-else>
            <span class="am-icon-envelope-o am-icon-sm am-block"> 邮箱验证码登录</span>
            <div class="am-form-group">
              <template v-if="!emailSent">
                <div class="am-input-group">
                  <input type="email" class="am-form-field am-radius" placeholder="请输入邮箱地址" v-model="email" @keyup.enter="sendLoginCode"/>
                  <span class="am-input-group-btn">
                    <button class="am-btn am-btn-primary am-radius" type="button" @click="sendLoginCode">获取验证码</button>
                  </span>
                </div>
              </template>
              <template v-else>
                <p class="am-text-sm am-text-secondary am-margin-bottom">验证码已发送到您的邮箱，请查收后输入下方</p>
                <input type="email" class="am-form-field am-radius" placeholder="邮箱" :value="email" readonly/>
              </template>
            </div>
            <div class="am-form-group">
              <input type="text" class="am-form-field am-radius" placeholder="请输入4位验证码，回车登录" v-model="verificationCode" maxlength="4" @keyup.enter="login"/>
            </div>
          </template>
        </div>
      </div>
      <div v-highlight class="am-article-bd" v-html="html"></div>
    </article>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import marked from 'marked'
import hljs from "highlight.js"
import 'highlight.js/styles/vs2015.css'
import { apiPageGet, apiLogin, apiBind, apiSendLoginCode, apiCompleteProfile, apiUploadAvatar, apiGetProfile, apiGetMyProfile, apiSaveProfile, apiSendBindEmailCode, apiConfirmBindEmail } from '@/request'
import {Toast} from "mint-ui"
export default {
  name: 'Login',
  data () {
    return {
      title: '',
      content: '',
      description: '',
      email: '',
      nickName: '',
      avatarUrl: '',
      webUrl: '',
      note: '',
      profileCode: '',
      needProfile: false,
      emailSent: false,
      verificationCode: '',
      showProfileEditor: false,
      showBindEmail: false,
      bindNewEmail: '',
      bindCode: '',
      bindCodeSent: false
    }
  },
  mounted () {
    this.resetData()
  },
  computed: {
    ...mapGetters([ 'option', 'loginUser' ]),
    defaultAvatar () {
      return 'https://api.0x0z.com/face.png'
    },
    html () {
      return marked.parse(this.content)
    }
  },
  watch: {
    $route: {
      handler (to) {
        this.resetData()
        if (to.query.tab === 'bind' && this.loginUser) {
          this.$nextTick(() => { this.showBindEmail = true })
        }
      }
    },
    title () {
      this.seo()
    },
    option () {
      this.seo()
    },
    loginUser () {
      this.loadContent()
    }
  },
  methods: {
    resetData () {
      this.emailSent = false
      this.needProfile = false
      this.showProfileEditor = false
      this.showBindEmail = false
      this.bindCodeSent = false
      this.bindNewEmail = ''
      this.bindCode = ''
      this.nickName = ''
      this.avatarUrl = ''
      this.webUrl = ''
      this.note = ''
      this.profileCode = ''
      this.bind()
      this.loadContent()
      const renderer = new marked.Renderer()
      const linkRenderer = renderer.link
      renderer.link = (href, title, text) => {
        const html = linkRenderer.call(renderer, href, title, text)
        return html.replace(/^<a /, '<a target="_blank" ')
      }
      marked.setOptions({
        renderer: renderer,
        pedantic: false,
        gfm: true,
        tables: true,
        breaks: true,
        sanitize: false,
        smartLists: true,
        smartypants: false,
        xhtml: false
      })
    },
    loadContent () {
      const slug = !this.loginUser ? 'login' : 'ucenter'
      apiPageGet({ slug, description: true }).then(res => {
        this.title = res.title
        this.content = res.content
        this.description = res.description
      })
    },
    bind () {
      if(this.$route.query.bind) {
        apiBind({ verificationCode: this.$route.query.bind }).then(res => {
          this.$store.commit('loginUser', res)
          Toast('登录成功')
        })
      }
    },
    seo () {
      if(this.title) {
        document.title = `${this.title}｜${this.option.title}`
        document.querySelector('meta[name="description"]').setAttribute('content', `${this.description}`)
        document.querySelector('meta[name="keywords"]').setAttribute('content', `${this.option.keywords},${this.title}`)
      } else {
        document.title = this.option.title
        document.querySelector('meta[name="description"]').setAttribute('content', this.option.description)
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.option.keywords)
      }
    },
    sendLoginCode () {
      if (!this.email) {
        Toast('请输入邮箱')
        return
      }
      apiSendLoginCode({ email: this.email }).then(() => {
        this.needProfile = false
        this.emailSent = true
        Toast('登录验证码已发送到您的邮箱')
      }).catch((err) => {
        if (err && err.msg && err.msg.indexOf('完善') !== -1) {
          this.needProfile = true
          // 拉取已保存的资料用于回显
          apiGetProfile({ email: this.email }).then(res => {
            if (res) {
              this.nickName = res.nickName || ''
              this.avatarUrl = res.avatarUrl || ''
              this.webUrl = res.webUrl || ''
              this.note = res.note || ''
            }
          }).catch(() => {})
        }
      })
    },
    toggleProfileEditor () {
      this.showBindEmail = false
      this.showProfileEditor = !this.showProfileEditor
      if (this.showProfileEditor && this.loginUser) {
        // 打开编辑时请求最新资料，保证邮箱、网站、签名等都能回显（不依赖 localStorage 里的旧 loginUser）
        apiGetMyProfile({ userId: this.loginUser.id }).then(res => {
          this.avatarUrl = res.avatarUrl || ''
          this.nickName = res.nickName || ''
          this.webUrl = res.webUrl || ''
          this.note = res.note || ''
          this.$store.commit('loginUser', { ...this.loginUser, ...res })
        }).catch(() => {})
      }
    },
    triggerProfileAvatarClick () {
      if (this.$refs.profileAvatarInput) {
        this.$refs.profileAvatarInput.click()
      }
    },
    onAvatarChange (e) {
      const file = e.target.files && e.target.files[0]
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      apiUploadAvatar(formData).then(url => {
        this.avatarUrl = url
      })
    },
    completeProfileAndSend () {
      if (!this.nickName || !this.nickName.trim()) {
        Toast('请输入昵称')
        return
      }
      if (!this.profileCode || !this.profileCode.trim()) {
        Toast('请输入邮件中的验证码')
        return
      }
      apiCompleteProfile({
        email: this.email,
        nickName: this.nickName.trim(),
        avatarUrl: this.avatarUrl,
        webUrl: this.webUrl && this.webUrl.trim(),
        note: this.note && this.note.trim(),
        verificationCode: this.profileCode.trim()
      }).then((res) => {
        this.$store.commit('loginUser', res)
        Toast('登录成功')
        this.needProfile = false
        const path = this.$route.query.jump
        if (path) {
          this.$router.push({ path })
        }
      })
    },
    toggleBindEmail () {
      this.showProfileEditor = false
      this.showBindEmail = !this.showBindEmail
      if (!this.showBindEmail) {
        this.bindCodeSent = false
        this.bindNewEmail = ''
        this.bindCode = ''
      }
    },
    sendBindEmailCode () {
      if (!this.bindNewEmail || !this.bindNewEmail.trim()) {
        Toast('请输入新邮箱')
        return
      }
      const newEmail = this.bindNewEmail.trim()
      if (this.loginUser.email && this.loginUser.email.trim().toLowerCase() === newEmail.toLowerCase()) {
        Toast('新邮箱不能与当前邮箱相同')
        return
      }
      apiSendBindEmailCode({
        userId: this.loginUser.id,
        newEmail
      }).then(() => {
        this.bindCodeSent = true
        Toast('验证码已发送到新邮箱')
      })
    },
    confirmBindEmail () {
      if (!this.bindCode || !this.bindCode.trim()) {
        Toast('请输入验证码')
        return
      }
      apiConfirmBindEmail({
        userId: this.loginUser.id,
        newEmail: this.bindNewEmail.trim(),
        verificationCode: this.bindCode.trim()
      }).then((res) => {
        this.$store.commit('loginUser', res)
        Toast('换绑成功')
        this.showBindEmail = false
        this.bindCodeSent = false
        this.bindNewEmail = ''
        this.bindCode = ''
      })
    },
    saveProfile () {
      if (!this.nickName || !this.nickName.trim()) {
        Toast('请输入昵称')
        return
      }
      if (!this.avatarUrl) {
        Toast('请先上传头像')
        return
      }
      apiSaveProfile({
        nickName: this.nickName.trim(),
        avatarUrl: this.avatarUrl,
        webUrl: this.webUrl && this.webUrl.trim(),
        note: this.note && this.note.trim()
      }).then((res) => {
        this.$store.commit('loginUser', res)
        Toast('保存成功')
        this.showProfileEditor = false
      })
    },
    login () {
      if(this.verificationCode) {
        apiLogin({ verificationCode: this.verificationCode }).then(res => {
          this.$store.commit('loginUser', res)
          Toast('登录成功')
          const path = this.$route.query.jump
          if(path) {
            this.$router.push({path})
          }
        })
      }
    },
    logout () {
      this.$store.commit('loginUser', null)
      Toast('注销登录成功')
      const path = this.$route.query.jump
      if(path) {
        this.$router.push({path})
      }
    }
  }
}
</script>

<style scoped>
.avatar {
  width: 75px;
  height: 75px;
}
.avatar-wrap {
  display: inline-block;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue